import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import ProductCardStatic from 'components/consumer/ProductCardStatic';
const ProductGridItem = t0 => {
  const $ = _c(19);
  const {
    eagerImageCount: t1,
    idx,
    layout,
    productItem
  } = t0;
  const eagerImageCount = t1 === undefined ? 0 : t1;
  let t2;
  if ($[0] !== idx || $[1] !== productItem.id) {
    t2 = productItem?.id?.toString() ?? `product-item-${idx}`;
    $[0] = idx;
    $[1] = productItem.id;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const key = t2;
  const t3 = idx < eagerImageCount;
  let t4;
  if ($[3] !== productItem.variantsToShow) {
    t4 = productItem.variantsToShow ?? [];
    $[3] = productItem.variantsToShow;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== productItem.variants) {
    t5 = productItem.variants ?? [];
    $[5] = productItem.variants;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = idx + 1;
  let t7;
  if ($[7] !== key || $[8] !== layout || $[9] !== productItem.id || $[10] !== productItem.isFavorited || $[11] !== productItem.name || $[12] !== productItem.productLabel || $[13] !== productItem.secondaryImage || $[14] !== t3 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6) {
    t7 = <ProductCardStatic disableImageLazyLoading={t3} layout={layout} id={productItem.id} name={productItem.name} variantsToShow={t4} variants={t5} secondaryImage={productItem.secondaryImage} productLabel={productItem.productLabel} isFavorited={productItem.isFavorited} position={t6} key={key} />;
    $[7] = key;
    $[8] = layout;
    $[9] = productItem.id;
    $[10] = productItem.isFavorited;
    $[11] = productItem.name;
    $[12] = productItem.productLabel;
    $[13] = productItem.secondaryImage;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};
ProductGridItem.propTypes = {
  idx: PropTypes.number,
  layout: PropTypes.oneOf(['full', 'mini', 'minimal', 'minimal-with-attributes', 'minimal-with-showroom']),
  productItem: PropTypes.shape({
    campaign: PropTypes.string,
    enableMobileCarousel: PropTypes.bool,
    filterStateKey: PropTypes.string,
    hidden: PropTypes.bool,
    id: PropTypes.number.isRequired,
    initialOptionId: PropTypes.string,
    isClearance: PropTypes.bool,
    isFavorited: PropTypes.bool,
    layout: PropTypes.oneOf(['full', 'mini', 'minimal', 'minimal-with-attributes', 'minimal-with-showroom']),
    moreVariantsCount: PropTypes.number,
    name: PropTypes.string,
    onDisplayInShowroomSlug: PropTypes.string,
    path: PropTypes.string,
    position: PropTypes.number,
    productFamily: PropTypes.string,
    productLabel: PropTypes.string,
    productType: PropTypes.string,
    quickship: PropTypes.bool,
    secondaryImage: PropTypes.string,
    secondaryImageCropData: PropTypes.object,
    slug: PropTypes.string,
    variantsToShow: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      image: PropTypes.string,
      isOutOfStock: PropTypes.bool,
      label: PropTypes.string,
      minPrice: PropTypes.number,
      originalPrice: PropTypes.number,
      path: PropTypes.string.isRequired,
      price: PropTypes.number.isRequired,
      quickship: PropTypes.bool,
      sku: PropTypes.string
    })),
    variants: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      image: PropTypes.string,
      isOutOfStock: PropTypes.bool,
      label: PropTypes.string,
      minPrice: PropTypes.number,
      originalPrice: PropTypes.number,
      path: PropTypes.string.isRequired,
      price: PropTypes.number.isRequired,
      quickship: PropTypes.bool,
      isFavorited: PropTypes.bool,
      sku: PropTypes.string
    })),
    variantsTotal: PropTypes.number
  })
};
export default ProductGridItem;